import { isVarTrue } from '@bluetrino/kamiokash-utils';

const NODE_ENV = process.env.NODE_ENV;

export const POSTHOG_PROJECT_TOKEN = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN;
export const POSTHOG_HOST = process.env.NEXT_PUBLIC_POSTHOG_HOST;

export const POSTHOG_DEBUG = isVarTrue(process.env.NEXT_PUBLIC_POSTHOG_DEBUG);

export const IS_DEVELOPMENT = NODE_ENV === 'development';

// PostHog only runs when both the token and the host are set.
// This is the one place that decides it, everything else reads this value.
export const HAS_POSTHOG_CONFIG = !!POSTHOG_PROJECT_TOKEN && !!POSTHOG_HOST;

// In development we warn instead of crashing, so the app still runs without PostHog
if (!HAS_POSTHOG_CONFIG && IS_DEVELOPMENT) {
  const missingVariable = POSTHOG_PROJECT_TOKEN
    ? 'NEXT_PUBLIC_POSTHOG_HOST'
    : 'NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN';

  console.warn(
    `${missingVariable} is not set, so PostHog is turned off and no events will be sent. Set it in .env.local if you need PostHog locally.`,
  );
}
